import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc-app/design-system';
import { FormInput } from '@occc-app/Offer/components/FormInput';
import { numberTOOrdinal } from '@occc-app/lib/format';

import { ProductGroupSelectEnhancedContainer as ProductGroupSelect } from './ProductGroupSelectEnhanced/ProductGroupSelectEnhancedContainer';

import {
  greaterThanZeroValidation,
  numberValidation,
  requiredValidation,
  withFormEventValidation,
} from '../../validatableComponent';
import { ButtonGroup } from '../../ButtonGroup';
import { State, Product as ProductType } from '../redux';
import { Column } from '../../Column';
import { Row } from '../../Row';

const PurchaseThresholdFormInput = withFormEventValidation(
  FormInput,
  requiredValidation,
  numberValidation,
  greaterThanZeroValidation,
);

type Product = ProductType & {
  idx: number;
  createOfferMode: boolean;
  editMode: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const Product: React.FC<Product> = (props) => {
  const {
    idx,
    countProductsBy,
    purchaseThreshold,
    editMode,
    fieldDisabled,
    eligibleProductGroups,
  } = props;

  return (
    <Box>
      <Row>
        <Column>
          <Typography variant='subtitle1' component='p'>
            {numberTOOrdinal(idx)} Product Definition
          </Typography>
        </Column>
      </Row>
      <Row>
        <Column>
          <ButtonGroup
            label='Count Product By'
            name='countProductsBy'
            readonly={fieldDisabled('countProductsBy')}
            selectedValue={countProductsBy}
          >
            <ButtonGroup.Option value='quantity'>Quantity</ButtonGroup.Option>
            <ButtonGroup.Option value='money_amount'>Money Amount</ButtonGroup.Option>
          </ButtonGroup>
        </Column>
      </Row>
      <Row>
        <Column>
          <PurchaseThresholdFormInput
            label='Purchase Threshold'
            readonly={fieldDisabled('purchaseThreshold')}
            type='text'
            value={purchaseThreshold}
            required={true}
          />
        </Column>
      </Row>
      <Row>
        <Column mb={4}>
          <ProductGroupSelect
            editMode={editMode}
            label='Included Product Groups'
            selectedProductGroups={eligibleProductGroups}
            onChange={() => {}}
            readonly={fieldDisabled('eligibleProductGroups')}
          />
        </Column>
      </Row>
    </Box>
  );
};

type ComponentState = State['emConfiguration']['varietyPurchase'];
type Fields = keyof ComponentState['products'][0];
export type Props = ComponentState & {
  createOfferMode: boolean;
  editMode: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const VarietyPurchaseConfiguration: React.FC<Props> = (props) => {
  const { createOfferMode, editMode, fieldDisabled, products } = props;

  const renderProduct = (product: ProductType, idx: number) => {
    return (
      <Row key={idx}>
        <Column p={2}>
          <Product
            idx={idx + 1}
            createOfferMode={createOfferMode}
            editMode={editMode}
            fieldDisabled={fieldDisabled}
            {...product}
          />
        </Column>
      </Row>
    );
  };

  // State does not care about the order of these products when adding/removing/updating
  // But the UI wants to preserve sorting order regardless of which was last updated
  const itemProducts = products
    .filter((product) => !product.removed)
    .sort((productA, productB) => productA.productIndex - productB.productIndex)
    .map(renderProduct);
  return <Box mb={4}>{itemProducts}</Box>;
};

export { VarietyPurchaseConfiguration };
